import * as actions from "../constants/actionTypes";

const initialState = {
    files: [],
    current: [],
    loading: false,
    saving: false,
    deleting: false,
    formData: {}
};

export default function files(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_FILES:
            newState.loading = true;
            break;

        case actions.SAVING_FILES:
            newState.saving = true;
            break;

        case actions.DELETING_FILES:
            newState.deleting = true;
            break;

        case actions.DONE_DELETING_FILES:
            newState.deleting = false;
            break;

        case actions.RECEIVED_FILES:
            newState.loading = false;
            newState.current = action.payload;
            break;

        case actions.ERROR_SAVING_FILES:
            newState.loading = false;
            newState.saving = false;
            break;

        default: break;
    }

    return newState;
}


// WEBPACK FOOTER //
// ./src/reducers/Files.js